import React, { useState } from 'react';
import { colors } from 'crono-fe-common/theme';

interface IconProps {
  size?: number;
  bgColor?: string;
  hoverBgColor?: string;
  strokeColor?: string;
}

const ManuallyPersonalisedMessageIcon = ({
  size = 24,
  bgColor = colors.blueLight,
  hoverBgColor = colors.blueLightHover,
  strokeColor = colors.intenseBlue,
}: IconProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const currentBgColor = isHovered ? hoverBgColor : bgColor;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ cursor: 'pointer' }}
    >
      <rect
        x="0.5"
        y="0.5"
        width="21"
        height="21"
        rx="10.5"
        fill={currentBgColor}
      />
      <rect x="0.5" y="0.5" width="21" height="21" rx="10.5" stroke="#D7DCEB" />
      <path
        d="M13.6932 10.0862L11.9141 8.30701"
        stroke={strokeColor}
        strokeWidth="1.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.20339 15.3752H6.62305V13.7948C6.62305 13.666 6.67409 13.5421 6.76548 13.4512L13.2473 6.96888C13.4374 6.77881 13.7451 6.77881 13.9346 6.96888L15.0289 8.06311C15.219 8.25318 15.219 8.56089 15.0289 8.75047L8.54707 15.2328C8.45617 15.3242 8.33221 15.3752 8.20339 15.3752V15.3752Z"
        stroke={strokeColor}
        strokeWidth="1.05"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5C13 15.4624 15.4624 13 18.5 13C21.5376 13 24 15.4624 24 18.5Z"
        fill="#0A9B94"
      />
      <path
        d="M16.5312 18.125L18.1063 19.625L20.4688 17.375"
        stroke="white"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ManuallyPersonalisedMessageIcon;
